<ng-container [ngTemplateOutlet]="blackFriday" *ngIf="blkOffer">
</ng-container>

<ng-container [ngTemplateOutlet]="percentOffer" *ngIf="!blkOffer">
</ng-container>

<ng-template #percentOffer>
  <div class="db-percent-offer-banner__head" *ngIf="!demoUser">
    <p><span>Optimize more</span>by spending less than before</p>
  </div>
  <div class="db-percent-offer-banner__content" [ngClass]="{'demoUser': !!demoUser}">
    <div class="db-percent-offer-banner__header mt25 mb30" *ngIf="!demoUser">
      <p class="mb6 mt10">{{userSubscription?.trialBoosterClient ? "Don’t miss this opportunity" :
        'Upgrade to a higher plan and achieve more with 10Web.'}}</p>
      <h4 class="db-percent-offer-banner__title">Get 60% off when<br/> upgrading to annual plans</h4>
    </div>

    <div class="db-percent-offer-banner__header mt25 mb30" *ngIf="!!demoUser">
      <h4 class="db-percent-offer-banner__title">Start a 7-day free<br/>trial of 10Web Pro now</h4>
      <p class="mb6 mt10">and get 50% off on annual plans</p>
    </div>

    <ng-container>
      <div class="text-center">
        <button class="ds-btn-green ds-btn-l mb12" (click)="claimOffer()">
          <span>{{(!!demoUser ? 'try 10Web pro for free' : 'upgrade to pro') | lowerCaseSpecificWords}}</span>
        </button>

        <div class="db-percent-offer-banner__money-back mb25">
          Cancel Anytime
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
<ng-template #blackFriday>
  <div class="db-percent-offer-banner__head">
    <p><span>This Black Friday,</span>an offer you can’t refuse</p>
  </div>
  <div class="db-percent-offer-banner__content">
    <db-percent-offer-counter></db-percent-offer-counter>

    <div class="db-percent-offer-banner__header mt20 mb20">
      <h4 class="db-percent-offer-banner__title mb10" [innerHTML]="title"></h4>
      <p [innerHTML]="(userSubscription?.trialClient || hideButton ? 'text_blkOfferFreePlanDesc' : 'text_blkOffer1wfPaidExpiredDesc')| dbText"></p>
    </div>

    <ng-container *ngIf="!hideButton && !oneWeekFreeExpired">
      <div class="text-center">
        <button class="ds-btn-gradient ds-btn-l mb25" (click)="claimOffer()">
          <span>Claim Your Discount</span>
        </button>
      </div>
    </ng-container>
  </div>
</ng-template>



